var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { isIOS, isPitu, isQQ, isWeChat } from '@tencent/h5-env-enhance';
import { openSharePanel, updateShareInfo, wakeUpQQ } from '@tencent/h5-share-enhance';
import { useDispatch, useSelector } from 'react-redux';
import { throttle } from 'lodash';
import style from './index.module.scss';
import ResultPage from '../../lib/components/Pages/ResultPageBaby';
import { updateCurPageAction } from '../../lib/common/store/reducer/actions';
import Modal from '../../lib/components/Modal';
import { getQueryParam } from '../../lib/utils';
import { reportBtnClick, reportError, reportPV, shareTraceAndChannelLink, } from '../../lib/utils/beacon';
import AdBanner from '../../lib/components/AdBanner';
import useLongPress from '../../lib/hooks/longPress';
import { saveQQImage, saveQQVideo } from '../../lib/utils/qq';
import { ERROR_CODE_MAPPING, generateCommonData } from '../H5ChristmasIndexPage/h5-config';
import { getBackendResult } from '../../lib/utils/fetch-data';
import { NET_WORK_ERROR } from '../../lib/constant/network';
const VALID_URL_PREFIX = 'https://act-artifacts.shadowcv.qq.com';
const H5BabyResultPage = ({ data: { resultPageShareMsg, backgroundImageUrl, adBannerSchema, adBannerUrl, replayBtnUrl, shareBtnUrl, saveBtnUrl, adBannerBackUrl, adScrollIcon, saveVideoBtnUrl, saveQQImageBtnUrl, videoFrameImgUrl, videoModalDownloadImageUrl, videoModalLongPressDownloadImageUrl, adBannerGif, loadingImgUrl, selectBoyUrl, selectGirlUrl, downloadUrl, feedImageUrl, feedUrl, logoUrl, closeBtnImgUrl, }, meta, global, }) => {
    const dispatch = useDispatch();
    const resultRef = useRef(null);
    // url 如果有的话
    const resultPageUrl = getQueryParam('result_page', '');
    const resultPosterUrl = getQueryParam('result_poster', '');
    const resUrl = resultPageUrl.startsWith(VALID_URL_PREFIX) ? resultPageUrl : '';
    const posterUrl = resultPosterUrl.startsWith(VALID_URL_PREFIX) ? resultPosterUrl : '';
    const fatherCropImage = useSelector(store => store.h5Baby.fatherOriginImg);
    const motherCropImage = useSelector(store => store.h5Baby.motherOriginImg);
    const resultImageUrl = useSelector(store => store.base.imageResultUrl);
    const videoResultUrl = useSelector(store => store.base.videoResultUrl);
    const videoResultDownloadImageUrl = useSelector(store => store.base.videoResultDownloadImageUrl);
    const boyResultUrl = useMemo(() => videoResultUrl || resUrl, [videoResultUrl, resUrl]);
    const boyResultImageUrl = useMemo(() => videoResultDownloadImageUrl || posterUrl, [
        videoResultDownloadImageUrl,
        posterUrl,
    ]);
    const girlResultUrl = useRef('');
    const girlResultImageUrl = useRef('');
    const selectedMaterial = useSelector(store => store.base.selectedMaterial);
    const [saveImgModalVisible, setSaveImgModalVisible] = useState(false);
    const adBannerRef = useRef(null);
    const [isAdBannerSeen, setAdBannerSeen] = useState(false);
    const isVideo = true;
    const [switchLoading, setSwitchLoading] = useState(false);
    const [errorModal, setErrorModal] = useState(false);
    const [feedbackMsg, setFeedbackMsg] = useState('');
    const [videoDownloadImageUrl, setVideoDownloadImageUrl] = useState('');
    const [currentVideoUrl, setCurrentVideoUrl] = useState('');
    const [switchOn, setSwitchOn] = useState(false);
    const commonData = generateCommonData(global);
    useEffect(() => {
        setCurrentVideoUrl(boyResultUrl);
        setVideoDownloadImageUrl(boyResultImageUrl);
    }, [boyResultUrl, boyResultImageUrl]);
    useEffect(() => {
        updateShareInfo({
            description: resultPageShareMsg || meta.desc,
            title: meta.title,
            imgUrl: getShareThumbnailUrl(),
            link: getShareLink(),
            sourceName: commonData.qqSource,
        });
    }, [currentVideoUrl, videoDownloadImageUrl]);
    const onReplayClick = () => {
        dispatch(updateCurPageAction('index'));
    };
    const getShareThumbnailUrl = () => {
        const originUrl = isVideo ? videoDownloadImageUrl : resultImageUrl;
        const thumbnailImageUrl = `${originUrl}?imageMogr2/crop/200x200`.replace('act-artifacts.shadowcv.qq.com', 'activity4tlimit-70160.picnjc.qpic.cn');
        return thumbnailImageUrl;
    };
    const getShareLink = () => {
        const resultUrl = isVideo ? currentVideoUrl : resultImageUrl;
        return `https://${window.location.host}${window.location.pathname}?source=link&result=${encodeURIComponent(resultUrl)}${isVideo ? `&poster=${encodeURIComponent(videoDownloadImageUrl)}` : ''}&${shareTraceAndChannelLink('link')}`;
    };
    const openShare = () => {
        openSharePanel({
            pituShareInfo: {
                description: resultPageShareMsg || meta.desc,
                imgUrl: getShareThumbnailUrl(),
                link: getShareLink(),
                title: meta.title,
                sourceName: commonData.qqSource,
            },
        });
    };
    // 分享：aio 分享视频，qq 其他保存视频+分享链接，端外：分享链接
    // 图片玩法时，都是分享链接
    const onShareClick = () => __awaiter(void 0, void 0, void 0, function* () {
        if (isQQ() && isVideo) {
            const isAio = getQueryParam('source') === 'aio';
            if (isAio) {
                yield resultRef.current.shareQQVideo();
            }
            else {
                // 调用 aecamera 保存视频
                saveQQVideo(currentVideoUrl);
                // 分享弹窗，仅保存视频，不分享
                // openShare();
            }
            return;
        }
        // 微信及p图跳转至qq
        if ((isWeChat() || isPitu()) && isVideo) {
            const url = setWakeQQUrl();
            wakeUpQQ(url, {
                downloadWhenWakeupFail: true,
            });
            return;
        }
        openShare();
    });
    const setWakeQQUrl = () => {
        const resultUrl = isVideo ? currentVideoUrl : resultImageUrl;
        const url = `https://${window.location.host}${window.location.pathname}?result_page=${encodeURIComponent(resultUrl)}${isVideo ? `&result_poster=${encodeURIComponent(videoDownloadImageUrl)}` : ''}`;
        return `mqqapi://forward/url?src_type=web&${isIOS() ? 'version=1' : 'plg_auth=1'}&url_prefix=${btoa(url)}&t=${new Date().getTime()}`;
    };
    // 监听滚动事件，得到ad-banner距离顶部的距离作为判断是否展现条件
    const onScroll = throttle(() => {
        // 至少看到banner10px, 才认为是有效曝光
        const minOffset = 10;
        const distance = adBannerRef.current.getBoundingClientRect().top;
        if (distance > window.innerHeight) {
            setAdBannerSeen(false);
            return;
        }
        if (distance + minOffset <= window.innerHeight && !isAdBannerSeen) {
            setAdBannerSeen(true);
            reportPV('result#ad-banner');
        }
    }, 500);
    useEffect(() => {
        const saveQQVideoFromWechat = () => __awaiter(void 0, void 0, void 0, function* () {
            saveQQVideo(resUrl);
        });
        // 校验
        if ((resUrl === null || resUrl === void 0 ? void 0 : resUrl.startsWith(VALID_URL_PREFIX)) && !videoResultUrl) {
            // 即url存在结果链接, 就自动下载
            saveQQVideoFromWechat();
        }
        updateShareInfo({
            description: resultPageShareMsg || meta.desc,
            title: meta.title,
            imgUrl: getShareThumbnailUrl(),
            link: getShareLink(),
            sourceName: commonData.qqSource,
        });
        onScroll();
    }, []);
    const onSaveImageClick = () => __awaiter(void 0, void 0, void 0, function* () {
        // 视频玩法弹窗保存，图片玩法，qq内可以保存，其余端长按保存
        if (isQQ()) {
            yield saveQQImage(videoDownloadImageUrl);
            return;
        }
        // 其余端弹出模态窗口
        if (isVideo) {
            setSaveImgModalVisible(true);
        }
    });
    const getShareBtnUrl = () => {
        if (isVideo) {
            return isQQ() ? saveVideoBtnUrl : shareBtnUrl;
        }
        return shareBtnUrl;
    };
    const getSaveImageBtnUrl = () => (isQQ() ? saveQQImageBtnUrl : saveBtnUrl);
    const handleImageLongPress = useLongPress(() => {
        reportBtnClick('result#long-press-save');
    });
    const handleImageResultLongPress = () => {
        reportBtnClick('result#long-press-save');
    };
    const handleModalSaveImage = () => __awaiter(void 0, void 0, void 0, function* () {
        // 模态窗口qq内保存图片
        if (!isQQ()) {
            return;
        }
        yield resultRef.current.saveQQImage(videoDownloadImageUrl);
    });
    const fetchVideo = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        setSwitchLoading(true);
        const imageBase64List = [fatherCropImage.split(',')[1], motherCropImage.split(',')[1]];
        // 后台请求
        try {
            const res = yield getBackendResult(selectedMaterial, imageBase64List, commonData.apiUrl, {
                // 默认是男性
                gender: 'female',
            });
            const isNetworkError = res.message === NET_WORK_ERROR;
            if (isNetworkError) {
                throw new Error('网络错误，请检查网络!');
            }
            const isError = res.data.code !== 0;
            if (isError) {
                const errMsg = ERROR_CODE_MAPPING[res.data.code]
                    ? ERROR_CODE_MAPPING[res.data.code].msg
                    : '活动太火爆了，请稍后再试';
                throw new Error(errMsg);
            }
            const extraInfo = JSON.parse(res.data.extra);
            // 更新store, 跳转结果页面
            girlResultUrl.current = (_a = extraInfo.video_urls) === null || _a === void 0 ? void 0 : _a[0];
            girlResultImageUrl.current = extraInfo.img_urls[0];
            setCurrentVideoUrl((_b = extraInfo.video_urls) === null || _b === void 0 ? void 0 : _b[0]);
            setVideoDownloadImageUrl(extraInfo.img_urls[0]);
            dispatch(updateCurPageAction('result'));
            setSwitchLoading(false);
            setSwitchOn(true);
        }
        catch (err) {
            setFeedbackMsg(err.message);
            setErrorModal(true);
            setSwitchLoading(false);
            reportError({ errMsg: err.message });
        }
    }), [selectedMaterial, fatherCropImage, motherCropImage]);
    const modalContent = () => (React.createElement("div", { className: style['feedback-modal'] },
        React.createElement("div", { className: style['feedback-modal-title'] }, feedbackMsg),
        React.createElement("div", { className: style['feedback-modal-action-btn'], onClick: () => {
                setErrorModal(false);
            } }, "\u597D\u7684")));
    const switchVideo = useCallback(() => {
        reportBtnClick('result#switch-baby');
        console.log('switch', girlResultUrl.current, girlResultImageUrl, boyResultUrl, boyResultImageUrl);
        if (!switchOn && girlResultUrl.current) {
            setCurrentVideoUrl(girlResultUrl.current);
            setVideoDownloadImageUrl(girlResultImageUrl.current);
            setSwitchOn(true);
            return;
        }
        if (!switchOn && !girlResultUrl.current) {
            fetchVideo();
            return;
        }
        setSwitchOn(false);
        setCurrentVideoUrl(boyResultUrl);
        setVideoDownloadImageUrl(boyResultImageUrl);
    }, [girlResultUrl, boyResultUrl, fetchVideo, switchOn]);
    const loadingContent = () => (React.createElement("div", { className: style['loading-modal'] },
        React.createElement("img", { src: loadingImgUrl, alt: "" })));
    // 当链接有url，但store里没有，代表从微信跳入，隐藏
    const hideSwitch = useMemo(() => resUrl && !videoResultUrl, [resUrl, videoResultUrl]);
    const handleClickFeedUrl = useCallback(() => {
        var _a, _b;
        // 暂停视频
        (_b = (_a = resultRef.current) === null || _a === void 0 ? void 0 : _a.getVideoRef().current) === null || _b === void 0 ? void 0 : _b.pause();
        window.open(feedUrl);
    }, []);
    return (React.createElement("div", { ref: adBannerRef, className: style['children-result-page'], onScroll: onScroll },
        React.createElement(Modal, { visible: saveImgModalVisible, containerStyle: { backgroundColor: 'rgba(0, 0, 0, .9)' }, hideModal: () => {
                setSaveImgModalVisible(false);
                // 保存图片弹窗modal曝光
                reportPV('result#save-image-modal');
            }, content: React.createElement("div", { className: style['result-img-modal'] },
                React.createElement("div", { className: style['result-img-modal-container'] },
                    React.createElement("img", Object.assign({ src: videoDownloadImageUrl, className: style['result-img-modal-res'], alt: "" }, handleImageLongPress)),
                    React.createElement("img", { src: closeBtnImgUrl, alt: "", className: style['result-img-modal-close'], onClick: () => setSaveImgModalVisible(false) })),
                React.createElement("img", { src: isQQ() ? videoModalDownloadImageUrl : videoModalLongPressDownloadImageUrl, alt: "", style: isWeChat() ? { pointerEvents: 'none' } : {}, className: style['result-img-modal-btn'], onClick: handleModalSaveImage })) }),
        React.createElement(ResultPage, { resultUrl: isVideo ? currentVideoUrl : resultImageUrl, isVideo: isVideo, shareResultImage: getShareBtnUrl(), downloadImage: getSaveImageBtnUrl(), posterImgUrl: videoDownloadImageUrl, replayBtnUrl: replayBtnUrl, styleCustom: style, handleReplayClick: onReplayClick, handleShareClick: onShareClick, showBackgroundUrl: backgroundImageUrl, handleSaveVideoResultImg: onSaveImageClick, videoFrameImgUrl: videoFrameImgUrl, isNeedAutoPlayHiddenBtn: isQQ(), onLongPressImage: handleImageResultLongPress, ref: resultRef, switchVideo: switchVideo, selectBoyUrl: selectBoyUrl, selectGirlUrl: selectGirlUrl, loadingUrl: downloadUrl, isShowSwitch: !hideSwitch, switchOn: switchOn },
            React.createElement(AdBanner, Object.assign({ onClickBanner: () => {
                    window.location.href = adBannerSchema;
                    reportBtnClick('result#ad-banner-click');
                }, isUseDefaultAction: !adBannerSchema.startsWith('http'), styleCustom: style }, { adScrollIcon, adBannerSchema, adBannerBackUrl, adBannerUrl, adBannerGif }),
                React.createElement("div", { className: style.bottom_div },
                    React.createElement("div", { className: style.feed_click_area, onClick: handleClickFeedUrl }),
                    React.createElement("img", { src: feedImageUrl, alt: "", className: style.feed_url }),
                    React.createElement("img", { src: logoUrl, alt: "", className: style.bottom_logo })))),
        React.createElement(Modal, { content: loadingContent(), visible: switchLoading, isClosedByClick: false, hideModal: () => setSwitchLoading(false) }),
        React.createElement(Modal, { content: modalContent(), visible: errorModal, hideModal: () => setErrorModal(false) })));
};
export default H5BabyResultPage;
